export const sweepQueryKeys = {
  all: ["sweep"] as const,
  entity: (userId: string) => [...sweepQueryKeys.all, userId] as const,
  reports: (userId: string) =>
    [...sweepQueryKeys.all, userId, "reports"] as const,
};

export default sweepQueryKeys;
